<template>
  <div>
    <el-dialog
      class="modal"
      title="刪除對應"
      :visible.sync="delModal"
      width="375px"
    >
      <el-input v-model="oneCode" placeholder="驗證碼"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="delModal = false" class="btn">取消</div>
        <div @click="confirmDel" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="請求對應"
      :visible.sync="addModal"
      width="375px"
    >
      <el-form :model="addData" label-position="top" v-if="addModal">
        <el-form-item label="商戶號">
          <el-input
            v-model="addData.customer_id"
            autocomplete="off"
            placeholder="請輸入商戶號"
          ></el-input>
        </el-form-item>
        <el-form-item label="請求輪詢代碼">
          <el-input
            v-model="addData.old_cm_id"
            autocomplete="off"
            placeholder="請輸入請求輪詢代碼"
          ></el-input>
        </el-form-item>
        <el-form-item label="對應輪詢代碼">
          <el-input
            v-model="addData.new_cm_id"
            autocomplete="off"
            placeholder="請輸入對應輪詢代碼"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">關閉</div>
        <div @click="confirmAdd" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-input
          v-model="searchData.customer_id"
          placeholder="商戶號"
        ></el-input>
      </el-form-item>
      <el-form-item label="請求代碼">
        <el-input
          v-model="searchData.old_cm_id"
          placeholder="請求代碼"
        ></el-input>
      </el-form-item>
      <el-form-item label="對應代碼">
        <el-input
          v-model="searchData.new_cm_id"
          placeholder="對應代碼"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-button size="mini" @click="add">添加對應</el-button>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="customer_id"
        label="商戶號"
      >
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="old_cm_id"
        label="請求代碼"
      >
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="old_cm_id"
        label="請求通道名稱"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.old_cm.channel_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="new_cm_id"
        label="對應代碼"
      >
      </el-table-column
      ><el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="old_cm_id"
        label="對應通道名稱"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.new_cm.channel_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button @click="delData(scope.row)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {},
      dataList: [],
      pagination: {},
      addModal: false,
      addData: {},
      delModal: false,
      oneCode: ""
    };
  },
  methods: {
    confirmDel() {
      this.$http.delete(
        `/back/collection_method/customer_models_change/${this.currentData.id}`
      );
    },
    delData(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.delModal = true;
      this.oneCode = "";
    },
    confirmAdd() {
      this.$http
        .post(`/back/collection_method/customer_models_change`, this.addData)
        .then(res => {
          if (res.data.code == 0) {
            this.getData();
            this.$message.success("成功");
            this.addModal = false;
          }
        });
    },
    add() {
      this.addData = {};
      this.addModal = true;
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      searchData.status = 0;
      this.$http
        .get(`/back/collection_method/customer_models_change`, {
          params: searchData
        })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
